

export default {
    methods:{
        reloadMyJobsTray(){
            const  vm = this
            this.isFullScreenLoading = true
            for(var i = 2;i<=5;i++) {
                const payloadDatTo = {
                    "user_id": this.user_id,
                    // "status_id": this.status
                    "status_id": i
                }

                this.fetchMyJobsTray(payloadDatTo)
                    .then(() => {
                        setTimeout(() => {
                            vm.isFullScreenLoading = false
                        }, 500)
                    })
                    .catch((err) => {

                        // console.log('do here 5555')

                        vm.isFullScreenLoading = false

                        // vm.isFullScreenLoading = false
                        vm.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })
            }
        }
    },



}